import { ShieldCheck, Stethoscope, TrendingDown, Clock, PiggyBank } from "lucide-react";

const ITEMS = [
  { icon: ShieldCheck, title: "Guaranteed Acceptance", body: "Coverage offered to all adults 50–85, regardless of health history." },
  { icon: Stethoscope, title: "No Medical Exam", body: "Skip the doctor's office — answer a few simple questions and you're done." },
  { icon: TrendingDown, title: "Rates Never Increase", body: "Your monthly premium is locked in for life. No surprises, ever." },
  { icon: Clock, title: "Coverage in 24 Hours", body: "Most policies are approved and active within one business day." },
  { icon: PiggyBank, title: "Affordable Premiums", body: "Plans starting as low as $8 a month so families on any budget can qualify." },
];

export default function Benefits() {
  return (
    <section id="benefits" className="py-20 lg:py-28 bg-ivory" data-testid="benefits-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <p className="text-xs sm:text-sm uppercase tracking-[0.22em] text-gold-deep font-semibold">Why Legacy Security Life</p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-navy leading-tight mt-3">
            Benefits That Bring Real Peace Of Mind.
          </h2>
          <div className="accent-line mt-5" />
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {ITEMS.map(({ icon: Icon, title, body }) => (
            <div
              key={title}
              data-testid={`benefit-${title.toLowerCase().replace(/\s+/g, "-")}`}
              className="bg-white rounded-xl border border-border p-7 lift-on-hover"
            >
              <span className="inline-flex h-12 w-12 items-center justify-center rounded-lg bg-[#0B203B]">
                <Icon className="h-6 w-6 text-[#E8C97A]" />
              </span>
              <h3 className="font-serif text-2xl text-navy mt-5">{title}</h3>
              <p className="text-navy/75 mt-2 leading-relaxed">{body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
